import React, {useContext} from 'react';
import Header from '../../Shared/Header';
import BreadCums from '../../Shared/BreadCums';
import {EmbeddableFAQ} from "../../../embeds/EmbeddableFAQ";
import {DemoContext} from "../../../lib/contexts/DemoContext";

const FAQManagementScreen = () => {
   
   const {
      state: { matchSM },
   } = useContext(DemoContext);
    return (
        <>
            <Header
                parentMenu='pages'
                headerClass='sc-header-section inner-header-style'
                signUpBtn='inner-btn'
            />
            <BreadCums pageTitle='FAQs' empty />
   
           <section className={`${matchSM ? '' :'sc-feature-section-area5'} sc-pt-30 sc-md-pt-30 sc-pb-140 sc-md-pb-70`}>
              <div className="container">
                 <div className="row align-items-center">
           <EmbeddableFAQ management/>
                 </div>
                 </div>
           </section>
        </>
    );
};

export default FAQManagementScreen;
